import { parseDateToLgComun4 } from "../../../helpers/dateTransform";

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'es';

const Kinds = {
  'report': {
    'es': 'reportes',
    'en': 'reports',
    'de': 'Berichte',
    'fr': 'rapports',
    'pt-BR': 'denúncias',
  },
  'involved': {
    'es': 'involucrados',
    'en': 'involved',
    'de': 'Beteiligte',
    'fr': 'impliqués',
    'pt-BR': 'envolvidos',
  },
  'investigation': {
    'es': 'investigación',
    'en': 'investigation',
    'de': 'Untersuchung',
    'fr': 'enquête',
    'pt-BR': 'investigação',
  },
  'other': {
    'es': 'Excel',
    'en': 'Excel',
    'de': 'Excel',
    'fr': 'Excel',
    'pt-BR': 'Excel',
  },
};

const createName = (kind, created, transalations, alias) => {
  const processedKind = !Kinds[kind][lang] ? 'Excel' : Kinds[kind][lang];

  try {
    return (
      <>
        {`${transalations.nameFirst} ${processedKind} ${transalations.nameSecond} ${created}`}
      </>
    );
  } catch {
    return '';
  }
};

const setFileData = (fileData, translations) => {
  const alias = fileData.alias ?? '';
  const kind = fileData.kind ?? 'other';
  const name = fileData.name ?? '';
  const created_at = parseDateToLgComun4(fileData.created_at) ?? '';
  const status = fileData.is_recent ?? false;

  // Fechas
  const currentDate = new Date();
  const createdDate = new Date(fileData.created_at);

  // Calcular la diferencia en días
  const millisecondsInADay = 24 * 60 * 60 * 1000;
  const daysDifference = Math.floor((currentDate - createdDate) / millisecondsInADay);
  const daysToExpire = 30 - daysDifference;

  // Determinar el estado de expiración
  let expires;
  if (daysToExpire > 0) {
    expires = `${daysToExpire} ${translations.days}`;
  } else {
    expires = translations.expired ?? 'Expired';
  }

  return {
    alias,
    name: !name ? createName(kind, created_at, translations, alias) : name,
    kind: !Kinds[kind][lang] ? 'Excel' : Kinds[kind][lang],
    created_at,
    status,
    expires,
    range_date: fileData.range_date,
    template_name: fileData.template__template_name,
    template_alias: fileData.template__alias,
    comment: fileData.comment,
    is_recent: fileData.is_recent,
  };
};

export default setFileData;